document.addEventListener('DOMContentLoaded', function() {
  function initVideoPopups() {
    const triggers = document.querySelectorAll('.video-popup-trigger');
    
    triggers.forEach(trigger => {
      const modalId = trigger.getAttribute('data-modal');
      const modal = document.getElementById(modalId);
      const closeBtn = modal.querySelector('.video-popup-close');
      const video = modal.querySelector('video');
  
      // Function to open the modal
      trigger.addEventListener('click', function() {
        modal.style.display = 'flex';
        modal.classList.add('active');
        video.play(); // Auto-play the video when opened
      });
  
      // Function to close the modal
      closeBtn.addEventListener('click', function() {
        modal.style.display = 'none';
        modal.classList.remove('active');
        video.pause(); // Pause the video when modal is closed
      });
  
      // Close modal if clicking outside the content area
      modal.addEventListener('click', function(event) {
        if (event.target === modal) {
          modal.style.display = 'none';
          modal.classList.remove('active');
          video.pause(); // Pause the video when modal is closed
        }
      });
    });
  }
  function reinitializeVideoPopups() {
    initVideoPopups(); 
  }
  reinitializeVideoPopups();

  document.addEventListener('shopify:section:load', function() {
    reinitializeVideoPopups();
  });

  document.addEventListener('shopify:section:select', function() {
    reinitializeVideoPopups();
  });

  window.addEventListener('load', function() {
    reinitializeVideoPopups();
  });
});
